import React from 'react'
import BaseModalPlain from 'components/BaseModalPlain'
import config from 'config'
import Logo from 'components/Logo'
import { redirectToLoginPage } from '@driftt/web-auth'
import './style.css'

const redirectToLogin = () => {
  redirectToLoginPage(config.AUTH_CLIENT_ID)
}

const MobileHeaderMenu = ({ onCloseInitiated }) => (
  <div className="public-home-mobile-menu">
    <BaseModalPlain onCloseInitiated={onCloseInitiated}>
      <Logo
        color="#394f5a"
        className="public-home-mobile-menu-logo"
      />
      <div className="public-home-mobile-menu-links">
        <a href="https://community.drift.com/categories/developer">
          Community
        </a>
        <a href="https://www.drift.com">
          Drift.com
        </a>
        <a href="https://devdocs.drift.com">
          Developer Docs
        </a>
        <button onClick={redirectToLogin}>
          Sign In
        </button>
      </div>

    </BaseModalPlain>
  </div>

)

export default MobileHeaderMenu
